import React from 'react';
import ProfileSidebar from '../../components/ProfileSidebar';

export default function Newsletter() {
  return (
    <section className="mt-[90px] max-w-[1440px] w-full mx-auto h-screen">
    <div className="flex flex-col flex-1 w-full">
      <div className="flex items-stretch flex-row justify-between w-full mx-auto">
        {/* 사이드바 */}
        <ProfileSidebar />
        {/* 프로필 콘텐츠 */}
        <article className="h-full w-full">
          <div className="w-full h-full flex flex-row items-start ">
            <div className="max-w-[1440px] w-full px-[80px] pt-[48px] pb-[80px]">
            <div className="bg-white shadow-lg rounded-lg p-9 w-full mx-auto h-[500px] flex">
        {/* 텍스트와 입력 영역 */}
        <div className="flex-1 flex flex-col justify-center">
          <div className="text-center mb-4">
            <h2 className="text-MainColor font-bold text-xl mb-2">크릿스토어 구독</h2>
            <p className="text-gray-700 mb-6">다양한 크릿스토어 이벤트 및 소식을 구독해서 확인해보세요</p>
          </div>
          <div className="mb-6">
            <input
              type="email"
              placeholder="이메일 주소를 입력해주세요"
              className="w-full h-[50px] border border-gray-300 rounded-md px-4 py-2 focus:outline-none"
            />
          </div>
          <button className="w-full h-[50px] tracking-wider bg-MainColor text-base font-medium text-white py-2 rounded-md hover:bg-opacity-80 transition duration-300">
            구독하기
          </button>
        </div>

        {/* 오른쪽 이미지 영역 */}
        <div className="flex-1 flex justify-center items-center">
          {/* 임시 이미지 */}
          <img
            src={`${process.env.PUBLIC_URL}/gif/moose-moosecraft.gif`} 
            alt="placeholder"
            className="w-[500px] h-[500px]"
          />
        </div>
      </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
  );
}
